import React from "react";
import { Li, StyledLiProps } from "./styles";

interface CalendarDateItemProps
  extends React.LiHTMLAttributes<HTMLLIElement>,
    StyledLiProps {}

const CalendarDateItem = React.memo(
  ({ children, ...rest }: CalendarDateItemProps) => {
    return (
      <Li {...rest}>
        <div>{children}</div>
      </Li>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.selected === nextProps.selected && !nextProps.selected;
  },
);
CalendarDateItem.displayName = "CalendarDateItem";

export default CalendarDateItem;
